<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>RESULTADOS DE INDUCCIÓN</h2></mat-dialog-content
>

<!-- <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed> -->


<mat-dialog-content class="modal-body">
  <div class="block-content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-3 control-label">Capacitador:</label>
        <div class="col-md-9">
            <mat-form-field
            class="example-full-width"
            appearance="outline"
          >
            <mat-label>Capacitador:</mat-label>
            <input
              type="text"
              placeholder=""
              aria-label="Number"
              matInput
              [formControl]="myControl"
              [matAutocomplete]="auto"
              name="codigoUsuario"
              maxlength="160"
            />
            <mat-autocomplete
              autoActiveFirstOption
              #auto="matAutocomplete"
              [displayWith]="displayFn"
              (optionSelected)='verificarUsuario($event)'
            >
              <mat-option
                *ngFor="let option of filteredOptions | async"
                [value]="option"
              >
                {{ option.firstName + " " + option.lastName + " - " + option.email  }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <!-- <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" [mat-dialog-close]="model" mat-button cdkFocusInitial>Guardar</button> -->
  <button
    class="btn btn-naranja"
    mat-button
    
    (click)="Save()"
    [disabled]="!existeEmpleado"
    cdkFocusInitial
  >
    Guardar
  </button>
  <button type="button" class="btn btn-celeste" mat-button (click)="onNoClick()">Cancelar</button>
</mat-dialog-actions>

<!-- </form> [mat-dialog-close]="model"-->

<!-- <pre>{{ fechaInduccion | json }}</pre>
<pre>{{ model.fechaHoraInduccion | date: "HH:mm" }}</pre> -->
<!-- <pre>{{ model | json }}</pre> -->

